import { render, staticRenderFns } from "./data-processing.vue?vue&type=template&id=1e305e4f&scoped=true"
import script from "./data-processing.vue?vue&type=script&lang=js"
export * from "./data-processing.vue?vue&type=script&lang=js"
import style0 from "./data-processing.vue?vue&type=style&index=0&id=1e305e4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e305e4f",
  null
  
)

export default component.exports